
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { languageMixin } from "@/mixins/languageMixin";
import {
  PostAddSource,
  GetSourceList,
  PutEditSource,
  DelSource,
} from "@/request/common";
import MainHeader from "@/components/main-header.vue";
@Component({
  components: {
    MainHeader,
  },
})
export default class Name extends mixins(listMixin, languageMixin) {
  private data: any = [];
  private editData: any = {};
  private ifShowAdd: any = false;
  private goAdd(val: any) {
    if (val) {
      this.editData = JSON.parse(JSON.stringify(val));
    } else {
      this.editData = {};
    }
    this.ifShowAdd = true;
  }
  private save() {
    if (!this.editData.name) {
      this.$message.warning("请输入来源名称");
      return;
    }
    if (this.editData.name.length > 10) {
      this.$message.warning("来源名称不能超过10个字");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (this.editData.id) {
      PutEditSource(this, this.editData.id, this.editData, loading).then(
        (res: any) => {
          loading.close();
          this.$message.success("保存成功");
          this.ifShowAdd = false;
          this.getList();
        }
      );
    } else {
      const params: any = {
        name: this.editData.name,
        introduce: this.editData.introduce,
      };
      PostAddSource(this, params, loading).then((res: any) => {
        loading.close();
        this.$message.success("保存成功");
        this.ifShowAdd = false;
        this.getList();
      });
    }
  }
  private delOne(item: any) {
    this.$confirm("确定删除该来源么？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        DelSource(this, item.id, loading).then(() => {
          this.$message.warning("删除成功");
          this.search();
        });
      })
      .catch((e) => {});
  }
  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      params: {
        search: this.filters.search,
        page: this.filters.current_page,
      },
    };
    localStorage.setItem("qudaoFilter", JSON.stringify(this.filters));
    GetSourceList(this, params)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    if (localStorage.getItem("qudaoFilter")) {
      this.filters = JSON.parse(localStorage.getItem("qudaoFilter") as any);
    }
    this.getList();
  }
}
